import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_PsychiatricAdvanceDirective = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_PsychiatricAdvanceDirective' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Psychiatric Advance Directive</h3></p>

                <p className='w-750'>
                    I, &nbsp;
                    <input type='text' name='txtPsychiatric' id='txtPsychiatric' className='add-only w-250 custom-add-only' /> 
                    &nbsp; have been educated on Psychiatric Advance Directives and have chosen not to execute one at this time.
                </p>
                <table>
                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Client Signature</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Legal Guardian/Parent Signature</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Lilly Pad Home Health, LLC Staff</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











